import { render, staticRenderFns } from "./CoachPlayersCoachedRow.vue?vue&type=template&id=970c0b1c&"
import script from "./CoachPlayersCoachedRow.vue?vue&type=script&lang=ts&"
export * from "./CoachPlayersCoachedRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports